import MdaeDateBox from "./component";
import { IDateBoxOptions } from "devextreme-react/date-box";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeDateBoxOption extends IDateBoxOptions {
  id: string;
  mdaeDateBoxTitle: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
  required?: boolean;
}
export default MdaeDateBox;
